import React from 'react'
import styled from '@emotion/styled'
import { array, string } from 'prop-types'
import { makeImgResizerUrl } from '@jelly/utils'

const BrandWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.white};
	height: 100%;
	padding: 5rem 1rem;
	width: 100%;
`
const TopBrandsTitle = styled.h2`
	${({ theme }) => theme.fonts.primarySemiBold};
	align-items: center;
	color: ${({ theme }) => theme.colors.primary};
	display: flex;
	font-size: 2rem;
	letter-spacing: -0.53px;
	line-height: 48px;
	justify-content: center;
	margin: 0 auto;
	text-align: center;
	width: 100%;
`
const TopBrandsContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	margin: 2rem auto 0;

	${({ theme }) => theme.MQ.M} {
		flex-direction: row;
		flex-wrap: wrap;
	}
`
const BrandImage = styled.img`
	height: auto;
	margin: 1rem 2rem;
	max-height: 100px;
	max-width: 200px;
	width: auto;
`
TopBrands.propTypes = {
	logos: array.isRequired,
	sectionTopBrandTitle: string.isRequired,
}
/**
 * Grid displaying list of available logos
 *
 * @param {Array} props.logos :: list of logo paths to display
 * @param {String} props.sectionTopBrandTitle :: title of the section
 * @returns
 */
function TopBrands({ logos, sectionTopBrandTitle = 'Our Top Brands' }) {
	return (
		<BrandWrapper>
			<TopBrandsTitle>{sectionTopBrandTitle}</TopBrandsTitle>
			<TopBrandsContainer>
				{logos.map(({ description, url }, i) => {
					return (
						<BrandImage
							key={`brand-logo-${i}`}
							src={makeImgResizerUrl({
								src: url,
								method: 'w',
								w: '200-png',
							})}
							alt={`${description}-logo`}
						/>
					)
				})}
			</TopBrandsContainer>
		</BrandWrapper>
	)
}

export default TopBrands
